import React, { useContext, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { firebaseAuth } from '../../../services/firebase'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import {
  VendorContextInterface,
  VendorContext
} from '../../../contexts/vendorContext'
import { signup } from '../../../services/vendorService'
import { toast } from 'react-toastify'
import SignupForm from './signupForm'
import { Link } from 'react-router-dom'

const handleEmailSignup = async (
  companyName: string,
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  vendorContext: VendorContextInterface
) => {
  // Call `signupVendor()` function to create a vendor & vendorUser doc for this signup
  await firebaseAuth()
    .createUserWithEmailAndPassword(email, password)
    .then(() => {
      return signup(companyName, firstName, lastName)
    })
    .then(newProfile => {
      if (newProfile) {
        vendorContext.setProfile(newProfile)
        return true
      } else {
        // @TODO: handle signup error
        return false
      }
    })
    .catch(err => {
      console.error('Vendor signup error:', err)
      const message = friendlyMessageFor(err.code as string)
      toast.error(message, { autoClose: false })
      return false
    })
}

function SignUp() {
  const vendorContext = useContext(VendorContext)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div className="box">
      <Row className="pb-3">
        <Col data-testid="onboarding-signup-text" xs={10}>
          <h2>Create an Account</h2>
        </Col>
      </Row>
      <Row data-testid="onboarding-signup">
        <Col>
          <SignupForm
            emailSignupCallback={(
              company,
              firstName,
              lastName,
              email,
              password
            ) => {
              setIsLoading(true)
              handleEmailSignup(
                company,
                firstName,
                lastName,
                email,
                password,
                vendorContext as VendorContextInterface
              ).then(() => {
                setIsLoading(false)
              })
            }}
            isLoading={isLoading}
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-center mt-4">
          <span className="gray-text">
            Already have an account?{' '}
            <Link to="/vendor/login">Sign in here</Link>.
          </span>
        </Col>
      </Row>
    </div>
  )
}

export default SignUp
